module.exports = __webpack_public_path__ + "static/home-about-74d91e1be069dfcf594c793626540f36.svg";